<template>
  <generic-modal
    @close="closeSearchModal($event, '')"
    :height="searchModalDim.height"
    :width="searchModalDim.width"
    :modalClass="searchModalDim.modalClass"
    :contentScroll="false"
    :genericModalSource="'searchModal'"
    :dependentComputedProps="{
      showProductCardInModalFor,
    }"
  >
    <template v-slot:header> </template>
    <template v-slot:body>
      <div :class="[clientPlatform == 'Web' ? 'ete-wrap' : '']">
        <div
          :class="[
            clientPlatform == 'Web' ? 'container-desktop' : 'container-pwa',
            focused ? 'focused' : '',
          ]"
        >
          <div
            class="search-modal-input-container"
            :class="{ 'bg-white': searchText.length > 0 }"
          >
            <i
              class="hkfi-arrow-line fs-16 mr15 hand"
              @click="closeSearchModal($event, 'cross')"
            ></i>
            <input
              class="search-query-input medium fs-14"
              :class="{ 'bg-white': searchText.length > 0 }"
              id="searchQueryInputModal"
              type="text"
              name="searchQueryInputModal"
              :placeholder="this.modulePropsParsed?.placeHolder"
              v-model="searchText"
              @input="activeDebounce($event.target.value)"
              @focus="onFocus"
              @blur="onBlur"
            />
            <img
              @click="clearSearchModal()"
              class="search-cross color-black fs-xlg"
              v-if="searchText.length > 0"
              :src="staticImgBaseUrl + '/images/global/clear-icon.svg'"
              alt="location-pin"
            />
            <i v-if="searchText.length == 0" class="hkfi-search-lens fs-18"></i>
          </div>
        </div>
      </div>
      <div :class="[clientPlatform == 'Web' ? 'container-desktop' : '']">
        <div
          class="no-result no-result-search"
          v-if="
            Object.keys(productSearchResults).length === 0 &&
            !isPopularSearchToggle
          "
        >
          <img
            :src="modulePropsParsed.emptyViewImage"
            alt="No Result"
            class="width100"
          />
          <div class="no-result-content fs-14 plr16">
            {{ modulePropsParsed?.emptySearchSubTitle }}
          </div>
        </div>
      </div>
      <div
        :class="[
          clientPlatform == 'Web' ? 'lg-cards-wrapper container-desktop' : '',
          isPopularSearchToggle ? '' : 'mb100',
        ]"
      >
        <hongs-product-card
          v-for="(value, key, index) in productSearchResults"
          :key="key"
          :data-item="value"
          :data-smallCards="true"
          :data-item-index="index"
          :showFullInfo="true"
          :searchText="searchText"
        ></hongs-product-card>
      </div>
      <div
        class="plr16"
        :class="[
          clientPlatform == 'Web' ? 'lg-cards-wrapper container-desktop' : '',
        ]"
        v-if="
          Object.keys(productSearchResults).length === 0 &&
          isPopularSearchToggle
        "
      >
        <div class="fs-14 popular-search bold mt8 mb15">
          {{ modulePropsParsed?.title }}
        </div>
        <div class="popular-list">
          <div
            v-for="(item, ind) in popularSearchItemList"
            :key="ind"
            :class="['color-base cursor-pointer ib popular-item']"
            @click="popularItemFun(item.originalText, ind)"
          >
            <i class="hkfi-back mr5"></i>
            <span class="bold">{{ item.selectedText }}</span>
            <span>{{ item.unselectedText }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div><bottom-bar></bottom-bar></div>
    </template>
  </generic-modal>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import InlineNotification from "./InlineNotification.vue";
import HongsProductCard from "./HongsProductCard.vue";
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";
import debounce from "lodash/debounce";
import Utility from "../helpers/utility";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import { getVwoExperimentsPromiseArray } from "../helpers/vwoSetup";
import { VWO_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import {
  EVENT_PAGEVIEW_SEARCHPAGE,
  EVENT_TYPE_SEARCHINPUT,
  EVENT_IMPRESSION_SEARCHRESULT,
  EVENT_CLICK_SEARCHOPTION,
  loadAmplitudeUnsentEvents,
  EVENT_SEARCH_BACK_CLICK,
} from "../helpers/analyticsEvents";
import { initializeMetaTime } from "../helpers/metaEvents";

export default {
  name: "SearchModal",
  components: {
    GenericModal,
    InlineNotification,
    HongsProductCard,
  },
  props: ["moduleProps"],
  data() {
    return {
      searchModalDim: {
        width: "100vw",
        height: "100vh",
        modalClass: "full-screen-popup search-modal-wrap",
      },
      // downArrow,
      searchText: "",
      productSearchResults: {},
      isPopularSearchToggle: true,
      staticImgBaseUrl,
      modulePropsParsed: {},
      shouldProcessEventTypeSearchInput: false,
      clientPlatform,
      focused: false,
    };
  },
  async mounted() {
    // let fetchedVwoData = {};
    // await Promise.all([...getVwoExperimentsPromiseArray()])
    //   .then((data) => {
    //     data.forEach((element) => {
    //       for (let key in element) {
    //         fetchedVwoData[key] = element[key];
    //       }
    //     });
    //     this.$store.commit(
    //       keyMapsMutation.UPDATE_VWO_EXPERIMENTS,
    //       fetchedVwoData
    //     );
    //   })
    //   .catch((errors) => {});

    loadAmplitudeUnsentEvents();
    setTimeout(() => {
      initializeMetaTime();
    }, 5000);
    //userActivityTracking.pageView(0,"searchPageViewed");
    this.modulePropsParsed = JSON.parse(this.moduleProps);
    // document.body.classList.add("body-stop-scroll-mobile");
    EVENT_PAGEVIEW_SEARCHPAGE();
  },
  methods: {
    closeSearchModal(e, source) {
      e.stopPropagation();
      this.clearSearchModal();
      // this.$store.commit(keyMapsMutation.UPDATE_SHOW_SEARCH_MODAL, false);
      // document.body.classList.remove("body-stop-scroll-mobile");
      this.$emit("close");
      EVENT_SEARCH_BACK_CLICK();
      Utility.appBackButtonFunc();
      window.history.back();
    },
    activeDebounce: debounce(function (text) {
      /*       if (Utility.getSearchableText(text).length <= 2) {
        return;
      } */
      if (this.shouldProcessEventTypeSearchInput) {
        EVENT_TYPE_SEARCHINPUT();
        this.shouldProcessEventTypeSearchInput = false;
      }
      if (text.length >= 2) {
        this.searchItem(text);
        this.isPopularSearchToggle = false;
      } else if (text.length == 0) {
        this.isPopularSearchToggle = true;
        this.productSearchResults = {};
      }
    }, 500),
    clearSearchModal() {
      this.searchText = "";
      this.productSearchResults = {};
      this.isPopularSearchToggle = true;
    },
    searchItem(text) {
      this.productSearchResults =
        this.$store.getters[keyMapsGetter.PRODUCT_SEARCH_RESULTS](text);
      if (Object.keys(this.productSearchResults).length > 0) {
        EVENT_IMPRESSION_SEARCHRESULT({ category: text });
      }
    },
    popularItemFun(data, index) {
      this.isPopularSearchToggle = false;
      this.searchText = data || "";
      this.searchItem(data);
      EVENT_CLICK_SEARCHOPTION({ category: data });
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
    },
  },
  computed: {
    // showSearchModal() {
    //   let _ = this.$store.state.ProductItems.showSearchModal;
    //   if (_) {
    //     // this.productSearchResults =
    //     //   this.$store.getters[keyMapsGetter.PRODUCT_SEARCH_RESULTS]();

    //     this.shouldProcessEventTypeSearchInput = true;
    //   }
    //   return _;
    // },
    showProductCardInModalFor() {
      let showProductCardInModal =
        this.$store.state.ProductItems.showProductCardInModalFor;
      if (Object.keys(showProductCardInModal).length > 0) {
        setTimeout(() => {
          typeof searchQueryInputModal === "undefined"
            ? ""
            : searchQueryInputModal.blur();
        }, 0);
      }
      return showProductCardInModal;
    },
    popularSearchItemList() {
      if (this.searchText?.length) {
        return this.modulePropsParsed?.popularSearch?.split(",").map((text) => {
          if (!text.toLowerCase().startsWith(this.searchText.toLowerCase())) {
            return { unselectedText: text, originalText: text };
          } else {
            return {
              selectedText: text.substring(0, this.searchText.length),
              unselectedText: text.substring(this.searchText.length),
              originalText: text,
            };
          }
        });
      } else
        return (
          this.modulePropsParsed?.popularSearch?.split(",").map((text) => {
            return { unselectedText: text, originalText: text };
          }) || []
        );
    },
  },
};
</script>

<style></style>
